export default __webpack_public_path__ + "static/media/twitter.71d3ff4d.svg";